import { Component, OnInit, Input } from '@angular/core';
import { BaseStepComponent } from '../../base';

@Component({
  selector: 'visualizar-anexo',
  templateUrl: './visualizar-anexo.component.html'
})
export class VisualizarAnexoComponent extends BaseStepComponent {

  @Input() gerenciamentoAtividade: any;
  @Input() acao: string;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/visualizar-anexo-gerenciar-atividade/visualizar-anexo.component.ts